import { useState, useEffect } from 'react';
import { useExperienceContent } from '../../../../hooks/use-server-content';
import { EligibleModelsCitt } from '../../../../models/experiencefragments/quick-links';
import { ExperienceFragmentModel } from '../../../../services/content-service/content-service.interface';

export interface OwnerManualsAiMappingContentProps
    extends ExperienceFragmentModel {
    enUsModels: EligibleModelsCitt[];
}

export const useOwnerManualsAiMappingContent = (): OwnerManualsAiMappingContentProps | null => {
    const [
        ownerManualsAiMappingContent,
        setOwnerManualsAiMappingContent,
    ] = useState<OwnerManualsAiMappingContentProps | null>(null);
    const [experienceContent] = useExperienceContent<
        OwnerManualsAiMappingContentProps
    >(
        'ownermanuals',
        'omaivehiclelist',
        'owner_manuals_ai_map',
        undefined,
        false
    );
    useEffect(() => {
        if (experienceContent) {
            setOwnerManualsAiMappingContent(experienceContent);
        }
    }, [experienceContent]);
    return ownerManualsAiMappingContent;
};
